/**
 * Shared "nothing to show" placeholder used by the broker tools. Used
 * both when a Supabase fetch comes back empty (real outage) and when
 * filters reduce the list to zero. Pure presentational — no client
 * interactivity required.
 */
export default function EmptyState({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) {
  return (
    <div className="flex flex-col items-center rounded-xl border border-dashed border-gray-200 bg-gray-50 p-12 text-center">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#9ca3af"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <div className="mt-3 text-[15px] font-semibold text-gray-900">{title}</div>
      <div className="text-[13px] text-gray-500">{subtitle}</div>
    </div>
  );
}
